import React, { useEffect, useState, useRef } from 'react';
import M_TBG_BASIC_05 from './M_TBG_BASIC_05';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import * as pdfjsLib from 'pdfjs-dist';
import 'pdfjs-dist/build/pdf.worker.entry';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../Reducer/CommonReducer';

function M_TBG_BASIC_05F(props) {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [loading, setLoading] = useState(false);
  const [pdfImages, setPdfImages] = useState([]);
  const tableData = useRef([]);

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    setLoading(true);
    try {
      await GeneratePermitPdf();
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  // 이미지 Base64 변환
  const ConvertImageToBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  // PDF → 이미지 변환 함수
  const renderPdfToImages = async (pdfBlob) => {
    const pdf = await pdfjsLib.getDocument({ data: pdfBlob }).promise;
    const images = [];

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      await page.render({ canvasContext: context, viewport }).promise;
      images.push(canvas.toDataURL('image/png'));
    }

    setPdfImages(images);
  };

  const GeneratePermitPdf = async () => {
    setLoading(true);
    try {
      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TBM_R4',
            _DEP_CD: Commons.EncryptAES(userInfo.depCd),
          },
        ]
      );

      const data = result.data;

      if (!data || data[0]?.type === 'Error') {
        setPdfImages([]);
        return;
      }

      // 작업일시 날짜 포맷 지정
      data.forEach((item) => {
        const date1 = new Date(item.WORK_START_DATE); // "7/24/2025 9:00:00 AM"
        const date2 = new Date(item.WORK_END_DATE); // "7/24/2025 9:00:00 AM"

        const year = date1.getFullYear();
        const month = String(date1.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
        const day = String(date1.getDate()).padStart(2, '0');
        const hours = String(date1.getHours()).padStart(2, '0');
        const minutes = String(date1.getMinutes()).padStart(2, '0');

        const year2 = date2.getFullYear();
        const month2 = String(date2.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
        const day2 = String(date2.getDate()).padStart(2, '0');
        const hours2 = String(date2.getHours()).padStart(2, '0');
        const minutes2 = String(date2.getMinutes()).padStart(2, '0');

        item.WORK_START_DATE = `${year}-${month}-${day} ${hours}:${minutes}`;
        item.WORK_END_DATE = `${year2}-${month2}-${day2} ${hours2}:${minutes2}`;
      });

      tableData.current = data;
      const firstRow = data[0];

      const imageUrl_dep =
        Global.file.useUrl + 'files/' + firstRow.DEP_SIGN_PATH;
      const imageUrl_sm = Global.file.useUrl + 'files/' + firstRow.SM_SIGN_PATH;

      const base64Dep = firstRow.DEP_SIGN_PATH
        ? (await ConvertImageToBase64(imageUrl_dep)).replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          )
        : '';
      const base64Sm = firstRow.SM_SIGN_PATH
        ? (await ConvertImageToBase64(imageUrl_sm)).replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          )
        : '';

      const headerData = {
        ...firstRow,
        DEP_SIGN_PATH: firstRow.DEP_SIGN_PATH ? base64Dep : '',
        SM_SIGN_PATH: firstRow.SM_SIGN_PATH ? base64Sm : '',
      };

      const workTypesArray = tableData.current[0].WORK_TYPES?.split(',') || [];

      const TableDataMain = [
        {
          WT_001: workTypesArray.includes('WT_001'),
          WT_002: workTypesArray.includes('WT_002'),
          WT_003: workTypesArray.includes('WT_003'),
          WT_004: workTypesArray.includes('WT_004'),
          WT_005: workTypesArray.includes('WT_005'),
          WT_006: workTypesArray.includes('WT_006'),
        },
      ];

      const tableDataSingleRow = {};

      tableData.current.forEach((item) => {
        const keyBase = item.WORK_TYPE_DTL;
        tableDataSingleRow[`CHECK_CONFIRM_${keyBase}`] = '';
        tableDataSingleRow[`CHECK_NOT_APPLICABLE_${keyBase}`] = '';

        if (item.ITEM_CHECK === '0') {
          tableDataSingleRow[`CHECK_CONFIRM_${keyBase}`] = 'true';
        } else if (item.ITEM_CHECK === '1') {
          tableDataSingleRow[`CHECK_NOT_APPLICABLE_${keyBase}`] = 'true';
        }
      });

      const serializedTable = JSON.stringify([tableDataSingleRow]);

      const printData = {
        FileName: 'PER_BASIC',
        HeaderData: JSON.stringify(headerData),
        TableDataMain,
        TableData1: serializedTable,
        TableData2: serializedTable,
        TableData3: serializedTable,
        TableData4: serializedTable,
        TableData5: serializedTable,
        TableData6: serializedTable,
      };

      const pdfRes = await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      );

      if (
        !pdfRes?.data ||
        pdfRes?.headers['content-type'] !== 'application/pdf'
      ) {
        throw new Error('PDF 응답이 비어 있거나 PDF가 아닙니다.');
      }

      await renderPdfToImages(await pdfRes.data.arrayBuffer());
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  const goToPrevPage = () => {
    dispatch(CommonActions.setActiveStep(activeStep - 1));
  };
  return (
    <M_TBG_BASIC_05
      userInfo={userInfo}
      activeStep={activeStep}
      pdfImages={pdfImages}
      loading={loading}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      ActiveButton={props.ActiveButton}
      goToPrevPage={goToPrevPage}
    />
  );
}

export default M_TBG_BASIC_05F;
